import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { DataTable, DeleteModal } from "CommonComponent";
import {
  fetchBoundTasks,
  unbindTasksFromProgram,
  bindTasksToProgram,
} from "actions";
import EditTaskModal from "./components/EditTaskModal";
import TaskFilter from "./components/TaskFilter/TaskFilter";
import AccessRights from "utils/AccessRights";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const TaskViewTab = ({
  programId,
  taskExtraFiltersState,
  setTaskExtraFiltersState,
}) => {
  const dispatch = useDispatch();
  let location = useLocation();
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

  const { bound_tasks, isTasksLoading } = useSelector(
    (state) => state.programSetupState,
  );
  const session = useSelector((s) => s.session);
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  useEffect(() => {
    if (programId) {
      dispatch(fetchBoundTasks(programId, { object_viewed_id }));
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [programId]);

  const handleShowEdit = (task) => {
    setSelectedTask(task);
    setShowEdit(true);
  };

  const handleShowDelete = (task) => {
    setSelectedTask(task);
    setShowDelete(true);
  };

  const handleCloseDelete = () => {
    setShowDelete(false);
    setSelectedTask(null);
  };

  const handleUpdate = (data) => {
    //console.log("Task Updated!");
    //setShowEdit(false);
    let task_ids = [selectedTask.task.id];
    data = { ...data, object_viewed_id, task_ids };
    dispatch(bindTasksToProgram(programId, data, onEditModelClose));
  };

  const onEditModelClose = () => {
    setShowEdit(false);
    setSelectedTask(null);
  };

  const handleRemove = () => {
    if (selectedTask) {
      dispatch(
        unbindTasksFromProgram(programId, [selectedTask.id], object_viewed_id),
      );
      handleCloseDelete();
    }
  };

  const getActions = (row) => (
    <div className="d-flex align-items-center gap-2">
      {AccessRights(session.current_page_permissions, "edit", row.created_by) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
          >
            <img
              src="/assets/images/edit-icon.svg"
              alt="Edit"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowEdit(row)}
            />
          </OverlayTrigger>
        )}
      {AccessRights(
        session.current_page_permissions,
        "delete",
        row.created_by,
      ) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-unbind-${row.id}`}>Unbind The Task </Tooltip>}
          >
            <img
              src="/assets/images/detach-btn-icon.svg"
              alt="Unbind"
              style={{ cursor: "pointer" }}
              onClick={() => handleShowDelete(row)}
            />
          </OverlayTrigger>
        )}
    </div>
  );

  const Columns = () => [
    {
      id: "category",
      header: "Category",
      accessor: (row) => row.task?.category?.name || "N/A",
      sortable: true,
      searchable: true,
    },
    {
      id: "task",
      header: "Task",
      accessor: (row) => row.task?.name || "N/A",
      sortable: true,
      searchable: true,
    },
    {
      id: "rep_access",
      header: "Rep Access",
      accessor: (row) => (row.rep_access === 1 ? "Yes" : "No"),
      sortable: true,
      searchable: true,
    },
    {
      id: "actions",
      header: "Action",
      accessor: (row) => getActions(row),
      sortable: false,
      searchable: false,
    },
  ];

  return (
    <div>
      <TaskFilter
        taskExtraFiltersState={taskExtraFiltersState}
        setTaskExtraFiltersState={setTaskExtraFiltersState}
        object_viewed_id={object_viewed_id}
        programId={programId}
      />
      <DataTable
        columns={Columns({ getActions })}
        data={bound_tasks || []}
        serverSide={false}
        showSearch={false}
        isLoading={isTasksLoading}
        className="table-container"
      />
      <EditTaskModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        handleUpdate={handleUpdate}
        selectedRecord={selectedTask}
        handleShowDelete={handleShowDelete}
      />
      <DeleteModal
        show={showDelete}
        onClose={handleCloseDelete}
        onDelete={handleRemove}
        deleteBtnTxt="Unbind"
        message="Are you sure you want to unbind this task?"
      />
    </div>
  );
};

export default TaskViewTab;
